import axios from "axios";
import { DIRECT_DEPOSIT, SET_ERROR } from "../../types";
import ToastMessage, { renderImportStatus } from '../../../components/toast';
export const directDepositAction = (payload, fields) => {
    return async (dispatch) => {
        await axios.post('api/file-transform/direct-deposit', payload, fields).then(response => {
            dispatch({
                type: DIRECT_DEPOSIT,
                payload: response.data
            });
            ToastMessage("", "", { dismiss: true });
            ToastMessage(renderImportStatus(response.data), "success", { options: { delay: 500 } });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
            ToastMessage("", "", { dismiss: true });
            ToastMessage("Error Loading File, Please Contact Support", "error");
        });
    };
};
